import { BulletLayout } from '../Layouts/BulletLayout';
import * as React from 'react';

export const generateBullets = (bullets: any) => {
	let returnValue = null;
	if (bullets) {
		returnValue = bullets.map((bullet) => {
			const innerReturnValue = <BulletLayout bullet={bullet} />;
			return innerReturnValue;
		});
	}
	return returnValue;
};
